export const defaultOtherData = {
    truckNumber: '',
    s_flight_serial: ''
}

export const formatFlightNumber = (num: number) => {
    const str = String(num);
    const addDigits = 3 - str.length;
    return `${new Array(addDigits).fill(0).join('')}${str}E`;
}